export default function ContributorStats({listing}) {
  const {view_count, inquiry_count, view_percentile_3_day} = listing;

  return (
    <div className="listing-stats" title={`${view_count} views, ${inquiry_count} inquiries`}>
      <span><i className="icon-eye"/>{view_count}</span>
      <span><i className="icon-mail"/>{inquiry_count}</span>
      {view_percentile_3_day > 75 && <span title="Top 20% of views in last 3 days">🔥</span>}
    </div>
  );
}
